import { Trans, useLingui } from '@lingui/react/macro';

import { RadioItemYesNo } from '@/design_system/Radio/RadioItem/RadioItem';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { Brand, useUpdateBrand } from '@/models/brand';

export const OwnedByOrganization = ({ brand }: { brand: Brand }) => {
  const { t } = useLingui();
  const { mutateAsync: updateBrand, isPending: isUpdateBrandPending } = useUpdateBrand(brand.id);

  return (
    <Stack gap="0.5em">
      <Title as="h2" size="400" weight="medium">
        <Trans id="settings.organization.data-catalogs.brands.tab.overview.owned-by-organization">
          Owned by organization
        </Trans>
      </Title>

      <RadioItemYesNo
        name="owned-by-organization"
        ariaLabel={t({
          id: 'settings.organization.data-catalogs.brands.tab.overview.owned-by-organization',
          message: 'Owned by organization',
        })}
        value={brand.ownedByOrganization ? 'yes' : 'no'}
        onChange={(newValue) => {
          const newValueBoolean = newValue === 'yes' ? true : false;

          if (newValueBoolean !== brand.ownedByOrganization) {
            updateBrand({ ownedByOrganization: newValueBoolean });
          }
        }}
        disabled={isUpdateBrandPending}
      />
    </Stack>
  );
};
